import React from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Card } from '@americanexpress/dls-react';
import { useRouteParams } from '@/context/routeParamsContext';
import { useModal } from '@/context/modalContext';
import { cardArtMapping } from '@/constants/productMapping';
import { getLocaleData } from '@/selectors/localeSelectors';
import { getIsNotLoggedIn } from '@/selectors/authSelectors';
import { getMycaLoginFlag } from '@/selectors/experimentSelectors';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { getCardArtUrl } from '@/helpers/utils';
import { useAnalyticsContext } from '@/context/analyticsContext';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import styles from './CardCalloutNotification.module.scss';
import LoungeAccessProductDescription from './LoungeAccessProductDescription';
import { modalTypes } from './modals/constants';

const CardCalloutNotification = ({ className }) => {
  const { product } = useRouteParams();
  const { locale } = useSelector(getLocaleData);
  const { enabled: isMycaLoginEnabled } = useSelector(getMycaLoginFlag);
  const { customTrack } = useAnalyticsContext();
  const isNotLoggedIn = useSelector(getIsNotLoggedIn);
  const baseOneCmsImgUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const imgSrc = getCardArtUrl({
    baseOneCmsImgUrl,
    product: cardArtMapping[product],
    locale,
  });
  const { setModalName } = useModal();
  const { selectCard = {} } = useCommonContent();
  const cardSwitchLinkText =
    isMycaLoginEnabled && !isNotLoggedIn
      ? selectCard?.link_loggedIn
      : selectCard?.link;

  const handleToggleModal = (event) => {
    setModalName(modalTypes.SELECT_CARD_MODAL);
    customTrack({
      event,
      detail: 'card call out notification',
      element: 'change card button',
    });
  };

  return (
    <Card
      className={clsx(styles.cardCalloutNotification, className)}
      aria-label="Card Callout Notification"
      style={{ minWidth: 'unset' }}
    >
      <img
        src={imgSrc}
        alt="Card Callout Notification"
        className={styles.cardArt}
      />
      <div
        className={clsx(
          'dls-gray-06 tw-text-xs md_tw-text-base',
          styles.cardCalloutInfo
        )}
      >
        <div>
          <span>
            <LoungeAccessProductDescription locale={locale} product={product} />
          </span>
          <span className="md_tw-hidden">&nbsp;</span>
          <button
            type="button"
            className="tw-text-xs tw-text-link tw-underline md_tw-hidden"
            onClick={() => setModalName(modalTypes.SELECT_CARD_MODAL)}
          >
            {cardSwitchLinkText}
          </button>
        </div>
        <button
          type="button"
          className="tw-hidden tw-text-sm tw-text-link tw-underline md_tw-block"
          onClick={handleToggleModal}
        >
          {cardSwitchLinkText}
        </button>
      </div>
    </Card>
  );
};

CardCalloutNotification.propTypes = {
  className: PropTypes.string,
};

export default CardCalloutNotification;
